import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function TopNotchFeatures() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
               Top-Notch Features That Define Cutting-Edge Health & Fitness Apps
            </h2>
            <p className="section_desc cs-text-secondary mb-0">
               As specialists in Health & Fitness Software Development Services,
               we craft scalable, feature-rich solutions to improve patient
               care, user engagement, and overall wellness. From EMR platforms
               to AI-driven diagnostics and telehealth capabilities, our
               applications empower healthcare and fitness providers with
               seamless, secure, and smart digital tools that boost operational
               efficiency and deliver better health outcomes.
            </p>
            <div className="tn-section tn-section-grid">
               <div className="tn-content-wrap tn-1">
                  <svg
                     width="60"
                     height="54"
                     viewBox="0 0 60 54"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M7.5 53.25H51.25C55.3921 53.25 58.75 49.8921 58.75 45.75V17C58.75 16.3096 58.1904 15.75 57.5 15.75H15C14.3096 15.75 13.75 16.3096 13.75 17V47C13.75 50.4518 10.9518 53.25 7.5 53.25ZM7.5 53.25C4.04822 53.25 1.25 50.4518 1.25 47V2C1.25 1.30964 1.80964 0.75 2.5 0.75H17.5C18.1904 0.75 18.75 1.30964 18.75 2V7C18.75 7.69036 19.3096 8.25 20 8.25H51.25M46.25 32C46.25 31.3096 45.6904 30.75 45 30.75H38.75V24.5C38.75 23.8096 38.1904 23.25 37.5 23.25H32.5C31.8096 23.25 31.25 23.8096 31.25 24.5V30.75H25C24.3096 30.75 23.75 31.3096 23.75 32V37C23.75 37.6904 24.3096 38.25 25 38.25H31.25V44.5C31.25 45.1904 31.8096 45.75 32.5 45.75H37.5C38.1904 45.75 38.75 45.1904 38.75 44.5V38.25H45C45.6904 38.25 46.25 37.6904 46.25 37V32Z"
                        stroke="#1F473E"
                     />
                  </svg>
                  <h3 className="tn-title">EMR/EHR Platforms</h3>
                  <p className="tn-sub-des">Digitize clinical</p>
                  <p className="tn-sub-des">workflows with EMR</p>
                  <p className="tn-sub-des">and EHR systems.</p>
               </div>
               <div className="tn-content-wrap tn-2">
                  <svg
                     width="58"
                     height="58"
                     viewBox="0 0 58 58"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M30.4632 57.3392H4.79245C2.64065 57.3392 0.757812 55.4565 0.757812 53.3047V4.6948C0.757812 2.543 2.64065 0.660156 4.79245 0.660156H53.2083C55.36 0.660156 57.2428 2.543 57.2428 4.6948V36.017M0.757812 15.7774H57.2428M46.7588 34.5983V41.0312M43.3237 47.7362V50.6405M50.1963 47.7362V50.6405M29.0115 10.7711C30.3878 10.7711 31.5035 9.6554 31.5035 8.2791C31.5035 6.90283 30.3878 5.7871 29.0115 5.7871C27.6353 5.7871 26.5195 6.90283 26.5195 8.2791C26.5195 9.6554 27.6353 10.7711 29.0115 10.7711ZM19.0262 10.7711C20.4025 10.7711 21.5182 9.6554 21.5182 8.2791C21.5182 6.90283 20.4025 5.7871 19.0262 5.7871C17.6499 5.7871 16.5342 6.90283 16.5342 8.2791C16.5342 9.6554 17.6499 10.7711 19.0262 10.7711ZM9.0457 10.7711C10.422 10.7711 11.5377 9.6554 11.5377 8.2791C11.5377 6.90283 10.422 5.7871 9.0457 5.7871C7.66943 5.7871 6.5537 6.90283 6.5537 8.2791C6.5537 9.6554 7.66943 10.7711 9.0457 10.7711ZM41.2775 41.0325H52.2425C52.2425 41.0325 57.2425 41.0325 57.2425 46.0325V52.3425C57.2425 52.3425 57.2425 57.3425 52.2425 57.3425H41.2775C41.2775 57.3425 36.2775 57.3425 36.2775 52.3425V46.0325C36.2775 46.0325 36.2775 41.0325 41.2775 41.0325Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">AI Solutions</h3>
                  <p className="tn-sub-des">Optimize healthcare</p>
                  <p className="tn-sub-des">processes using AI</p>
                  <p className="tn-sub-des">and machine</p>
                  <p className="tn-sub-des">learning.</p>
               </div>
               <div className="tn-content-wrap tn-3">
                  <svg
                     width="57"
                     height="56"
                     viewBox="0 0 57 56"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M47.906 12.5295V4.89273C47.906 3.77846 47.4633 2.70983 46.6753 1.92193C45.8875 1.13403 44.8188 0.691406 43.7045 0.691406H10.0941C8.97978 0.691406 7.91116 1.13403 7.12325 1.92193C6.33536 2.70983 5.89273 3.77846 5.89273 4.89273V30.1006L1.69141 42.7046L9.43636 40.2803H13.1635M41.604 51.1071L56.3088 55.3086L54.208 42.7046V23.5801C54.208 22.4658 53.7655 21.3971 52.9775 20.6092C52.1895 19.8213 51.121 19.3787 50.0068 19.3787H22.6982C21.5839 19.3787 20.5153 19.8213 19.7274 20.6092C18.9395 21.3971 18.4968 22.4658 18.4968 23.5801L18.4969 46.9058C18.4969 48.0201 18.9395 49.0888 19.7274 49.8766C20.5153 50.6646 21.5839 51.1071 22.6982 51.1071H41.604ZM40.3738 26.4511H32.933V31.6403H27.541V39.0808H32.933V44.2701H40.3738V39.0808H45.3598V31.6403H40.3738V26.4511Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Patient Engagement</h3>
                  <p className="tn-sub-des">Enhance patient</p>
                  <p className="tn-sub-des">relationships with</p>
                  <p className="tn-sub-des">interactive software.</p>
               </div>
               <div className="tn-content-wrap tn-4">
                  <svg
                     width="60"
                     height="59"
                     viewBox="0 0 60 59"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M1.25 33.75V58.75M58.75 40V58.75M28.75 11.25H34.375C34.7684 11.25 35.1389 11.0648 35.375 10.75L37.655 7.7075C37.9023 7.37776 38.2962 7.19113 38.708 7.20862C39.1198 7.22612 39.4966 7.44548 39.715 7.795L44.165 14.9175C44.3667 15.2411 44.705 15.4549 45.0838 15.4983C45.4626 15.5416 45.8405 15.4097 46.11 15.14L49.6325 11.6175C49.8674 11.3832 50.1858 11.2519 50.5175 11.2525H58.75M6.25 40C6.25 43.4518 9.04822 46.25 12.5 46.25C15.9518 46.25 18.75 43.4518 18.75 40C18.75 36.5482 15.9518 33.75 12.5 33.75C9.04822 33.75 6.25 36.5482 6.25 40ZM1.25 46.25H58.75V53.75H1.25V46.25ZM23.75 46.25H53.75V38.75C53.75 35.9886 51.5114 33.75 48.75 33.75H25C24.3096 33.75 23.75 34.3096 23.75 35V46.25ZM28.75 18.75C28.75 20.1307 29.8693 21.25 31.25 21.25H56.25C57.6307 21.25 58.75 20.1307 58.75 18.75V3.75C58.75 2.36929 57.6307 1.25 56.25 1.25H31.25C29.8693 1.25 28.75 2.36929 28.75 3.75V18.75Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Hospital Administration</h3>
                  <p className="tn-sub-des">Simplify</p>
                  <p className="tn-sub-des">management with</p>
                  <p className="tn-sub-des">custom hospital</p>
                  <p className="tn-sub-des">software.</p>
               </div>
               <div className="tn-content-wrap tn-5">
                  <svg
                     width="59"
                     height="60"
                     viewBox="0 0 59 60"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M40.8613 28.75V40L33.2113 46.695C31.7179 48.0011 30.8612 49.8885 30.8613 51.8725C30.8599 55.6695 33.9369 58.7486 37.7338 58.75H51.4838C55.2808 58.75 58.3588 55.672 58.3588 51.875C58.3592 49.8922 57.5035 48.0058 56.0113 46.7L48.3613 40V28.75M31.0863 53.615L36.1938 51.0825C39.1087 49.6231 42.5601 49.7169 45.3913 51.3325C48.0454 52.8506 51.2579 53.0357 54.0688 51.8325L58.1113 50.05M25.8613 51.25H3.36133C1.98062 51.25 0.861328 50.1307 0.861328 48.75V11.25C0.861328 9.86929 1.98062 8.75 3.36133 8.75H10.8613M30.8613 8.75H38.3613C39.742 8.75 40.8613 9.86929 40.8613 11.25V23.75M37.1113 28.75H52.1113M12.1113 23.75H29.6113M12.1113 31.25H22.7363M29.6113 43.75H5.86133V13.75H10.8613M30.8613 13.75H35.8613V23.75M25.8613 6.25C25.8613 3.48858 23.6228 1.25 20.8613 1.25C18.0999 1.25 15.8613 3.48858 15.8613 6.25H12.1113C11.421 6.25 10.8613 6.80964 10.8613 7.5V15C10.8613 15.6904 11.421 16.25 12.1113 16.25H29.6113C30.3017 16.25 30.8613 15.6904 30.8613 15V7.5C30.8613 6.80964 30.3017 6.25 29.6113 6.25H25.8613Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Laboratory Management</h3>
                  <p className="tn-sub-des">Automate lab</p>
                  <p className="tn-sub-des">operations with</p>
                  <p className="tn-sub-des">LIMS platforms.</p>
               </div>
               <div className="tn-content-wrap tn-6">
                  <svg
                     width="58"
                     height="58"
                     viewBox="0 0 58 58"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M56.7021 30.6036V5.53517C56.7021 4.39977 56.2511 3.31087 55.4481 2.50805C54.6454 1.7052 53.5564 1.25415 52.4211 1.25415H9.61079C8.47539 1.25415 7.38649 1.7052 6.58364 2.50805C5.78079 3.31087 5.32976 4.39977 5.32976 5.53517V33.5454L1.04883 48.1964L18.1728 42.1074H20.8906M44.3704 12.3528H16.0778M27.5191 20.9436H16.078M47.8249 28.7016H37.3721V37.5791H28.4946V48.0319H37.3721V56.9094H47.8246V48.0319H56.7021V37.5791H47.8249V28.7016Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Medical Device Software</h3>
                  <p className="tn-sub-des">Ensure functionality</p>
                  <p className="tn-sub-des">and connectivity for</p>
                  <p className="tn-sub-des">medical devices.</p>
               </div>
               <div className="tn-content-wrap tn-7">
                  <svg
                     width="60"
                     height="60"
                     viewBox="0 0 60 60"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M28.7539 58.75H3.75391C2.37319 58.75 1.25391 57.6307 1.25391 56.25V3.75001C1.25391 2.3693 2.37319 1.25001 3.75391 1.25001H36.9789C37.6445 1.24816 38.2833 1.51179 38.7539 1.98251L48.0039 11.25C48.4728 11.7187 48.7363 12.3545 48.7364 13.0175V21.25M8.74641 38.75H31.2464M26.2539 38.75V20C26.2539 19.3097 25.6943 18.75 25.0039 18.75H22.5039C21.8136 18.75 21.2539 19.3097 21.2539 20V38.75M36.2539 28.75V25C36.2539 24.3097 35.6943 23.75 35.0039 23.75H32.5039C31.8136 23.75 31.2539 24.3097 31.2539 25V38.75M12.5039 26.25H15.0039C15.6943 26.25 16.2539 26.8097 16.2539 27.5V38.75H11.2539V27.5C11.2539 26.8097 11.8135 26.25 12.5039 26.25ZM38.7464 38.7525H56.2464C56.2464 38.7525 58.7464 38.7525 58.7464 41.2525V56.25C58.7464 56.25 58.7464 58.75 56.2464 58.75H38.7464C38.7464 58.75 36.2464 58.75 36.2464 56.25V41.2525C36.2464 41.2525 36.2464 38.7525 38.7464 38.7525ZM44.3714 48.9075C44.3714 50.6334 45.7705 52.0325 47.4964 52.0325C49.2223 52.0325 50.6214 50.6334 50.6214 48.9075C50.6214 47.1816 49.2223 45.7825 47.4964 45.7825C45.7705 45.7825 44.3714 47.1816 44.3714 48.9075ZM53.7539 35C53.7539 31.5482 50.9557 28.75 47.5039 28.75C44.0521 28.75 41.2539 31.5482 41.2539 35V38.75H53.7539V35Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Data Security</h3>
                  <p className="tn-sub-des">Protect patient</p>
                  <p className="tn-sub-des">information with</p>
                  <p className="tn-sub-des">secure software</p>
                  <p className="tn-sub-des">solutions.</p>
               </div>
               <div className="tn-content-wrap tn-8">
                  <svg
                     width="52"
                     height="61"
                     viewBox="0 0 52 61"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M43 16.25C41.6738 20.6273 40.9999 25.1762 41 29.75C41.163 39.4333 42.3225 49.0741 44.46 58.52C44.6247 59.2379 45.2635 59.7467 46 59.7467C46.7365 59.7467 47.3753 59.2379 47.54 58.52C49.6775 49.0741 50.837 39.4333 51 29.75C51.0001 25.1762 50.3262 20.6273 49 16.25M6 9.75H13.5M6 9.75V32.25M6 9.75C3.23858 9.75 1 11.9886 1 14.75V32.25M6 9.75V6C6 3.92893 7.67893 2.25 9.75 2.25C11.8211 2.25 13.5 3.92893 13.5 6V9.75M13.5 9.75V32.25M13.5 32.25H6M13.5 32.25V49.75M6 32.25V49.75M31 11V49.75M31 11L27.25 12.25L23.5 11M31 11L27.25 2.25L23.5 11M31 49.75H23.5M31 49.75V54.75M23.5 49.75V11M23.5 49.75V54.75M13.5 49.75H6M13.5 49.75C12.9342 52.7166 12.2132 55.6514 11.34 58.5425C11.1419 59.257 10.4915 59.7516 9.75 59.7516C9.00854 59.7516 8.35813 59.257 8.16 58.5425C7.2868 55.6514 6.56581 52.7166 6 49.75M23.5 54.75V56C23.5 58.0711 25.1789 59.75 27.25 59.75C29.3211 59.75 31 58.0711 31 56V54.75M23.5 54.75H31M46 2.25C49.3325 3.9175 51 8.9175 51 12.25C51 15.0114 48.7614 17.25 46 17.25C43.2386 17.25 41 15.0114 41 12.25C41 7.7875 46.8325 7.615 46 2.25Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Practice Management</h3>
                  <p className="tn-sub-des">Boost efficiency with</p>
                  <p className="tn-sub-des">all-in-one</p>
                  <p className="tn-sub-des">management</p>
                  <p className="tn-sub-des">systems.</p>
               </div>
               <div className="tn-content-wrap tn-9">
                  <svg
                     width="58"
                     height="58"
                     viewBox="0 0 58 58"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M14.365 40.1591L0.818359 44.8781L5.0993 30.2271V5.5352C5.0993 4.3998 5.55032 3.3109 6.35317 2.50805C7.15602 1.7052 8.24492 1.25416 9.38032 1.25416L42.9756 1.25415C44.1109 1.25415 45.1999 1.7052 46.0026 2.50805C46.8056 3.31087 47.2566 4.39977 47.2566 5.53517V27.8654M25.7046 18.9818C23.3658 18.9818 21.1227 19.9109 19.4688 21.5648C17.815 23.2186 16.8859 25.4619 16.8859 27.8006H34.5236C34.5236 25.4619 33.5944 23.2186 31.9406 21.5648C30.2866 19.9109 28.0436 18.9818 25.7046 18.9818ZM25.7046 18.9818C28.6204 18.9818 30.9844 16.6182 30.9844 13.7024C30.9844 10.7866 28.6206 8.42287 25.7049 8.42287C22.789 8.42287 20.4253 10.7866 20.4253 13.7024C20.4253 16.6182 22.7887 18.9818 25.7046 18.9818ZM44.1904 34.0694H22.2916C20.8566 34.0694 19.6934 35.2326 19.6934 36.6676V54.8544C19.6934 56.2894 20.8566 57.4526 22.2916 57.4526H44.1904C45.6254 57.4526 46.7886 56.2894 46.7886 54.8544V36.6676C46.7886 35.2326 45.6254 34.0694 44.1904 34.0694ZM46.7889 49.6569L55.4267 52.8959C55.6231 52.9694 55.8346 52.9944 56.0426 52.9684C56.2509 52.9424 56.4496 52.8666 56.6221 52.7471C56.7946 52.6276 56.9356 52.4681 57.0329 52.2821C57.1304 52.0964 57.1811 51.8896 57.1814 51.6799V39.8394C57.1811 39.6296 57.1299 39.4234 57.0324 39.2376C56.9351 39.0521 56.7939 38.8929 56.6217 38.7736C56.4492 38.6546 56.2502 38.5789 56.0421 38.5534C55.8341 38.5279 55.6229 38.5531 55.4267 38.6269L46.7889 41.8659V49.6569ZM30.2681 39.0096H35.9066V42.9419H39.9924V48.5801H35.9066V52.5124H30.2681V48.5801H26.4896V42.9419H30.2681V39.0096Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Telehealth Platforms</h3>
                  <p className="tn-sub-des">Expand care access</p>
                  <p className="tn-sub-des">with secure</p>
                  <p className="tn-sub-des">telehealth solutions.</p>
               </div>
               <div className="tn-content-wrap tn-10">
                  <svg
                     width="44"
                     height="56"
                     viewBox="0 0 44 56"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M21.999 23.0689C26.212 23.0689 29.6272 19.6536 29.6272 15.4406C29.6272 11.2276 26.212 7.81234 21.999 7.81234C17.786 7.81234 14.3707 11.2276 14.3707 15.4406C14.3707 19.6536 17.786 23.0689 21.999 23.0689ZM21.999 23.0689C18.2418 23.0689 14.6382 24.5617 11.9814 27.2184C9.3246 29.8752 7.83205 33.4784 7.83205 37.2359M21.999 23.0689C25.7564 23.0689 29.3595 24.5617 32.0162 27.2184C34.6732 29.8752 36.1657 33.4784 36.1657 37.2359M14.3707 33.2992H20.6642M17.5171 30.1522V36.4457M18.8355 48.5154H25.1627M43.0902 4.80001C43.0902 2.47036 41.2017 0.581787 38.8722 0.581787H5.12643C2.79678 0.581787 0.908203 2.47036 0.908203 4.80001V51.2004C0.908203 53.5299 2.79678 55.4187 5.12643 55.4187H38.8722C41.2017 55.4187 43.0902 53.5299 43.0902 51.2004V4.80001Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Precision Medicine</h3>
                  <p className="tn-sub-des">Deliver</p>
                  <p className="tn-sub-des">personalized care</p>
                  <p className="tn-sub-des">with precision</p>
                  <p className="tn-sub-des">medicine</p>
                  <p className="tn-sub-des">solutions.</p>
               </div>
               <div className="tn-content-wrap tn-11">
                  <svg
                     width="56"
                     height="56"
                     viewBox="0 0 56 56"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M28.9357 6.81682H2.79013C1.62995 6.81682 0.689453 7.75732 0.689453 8.9175V42.5284C0.689453 43.6884 1.62995 44.6289 2.79013 44.6289H53.2064C54.3667 44.6289 55.3072 43.6884 55.3072 42.5284V20.7509M23.7967 44.6289L19.5954 55.1324M32.1994 44.6289L36.4009 55.1324M15.394 55.1324H40.6022M11.1802 37.7416L19.6777 28.2859L25.5427 33.4326L34.1607 24.3361M17.479 14.771H9.3818M12.9771 22.1554H9.38048M48.8864 0.86792H41.3264V7.28867H34.9057V14.8486H41.3264V21.2691H48.8864V14.8486H55.3069V7.28867H48.8864V0.86792Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Medical Imaging</h3>
                  <p className="tn-sub-des">Improve</p>
                  <p className="tn-sub-des">diagnostic</p>
                  <p className="tn-sub-des">accuracy with</p>
                  <p className="tn-sub-des">advanced</p>
                  <p className="tn-sub-des">imaging solutions.</p>
               </div>
               <div className="tn-content-wrap tn-12">
                  <svg
                     width="58"
                     height="58"
                     viewBox="0 0 58 58"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M50.2231 50.2968L56.8169 56.8903M15.7677 18.9445L6.53394 28.1783M20.1456 9.34797C20.1456 13.8522 23.797 17.5035 28.3011 17.5035C32.8054 17.5035 36.4569 13.8522 36.4569 9.34797M20.1456 9.34797C20.1456 4.84377 23.797 1.19238 28.3011 1.19238C32.8054 1.19238 36.4569 4.84377 36.4569 9.34797M20.1456 9.34797H36.4569M40.0916 54.5016C48.0081 54.5016 54.4254 48.0841 54.4254 40.1678C54.4254 32.2513 48.0081 25.8338 40.0916 25.8338C32.1754 25.8338 25.7579 32.2513 25.7579 40.1678C25.7579 48.0841 32.1754 54.5016 40.0916 54.5016ZM12.2005 15.3764C10.9647 14.2082 9.32204 13.5681 7.62164 13.592C5.92127 13.6159 4.29724 14.302 3.09477 15.5045C1.8923 16.7069 1.20619 18.331 1.18229 20.0313C1.15838 21.7317 1.79857 23.3744 2.96674 24.6103L10.8364 32.4798C12.0654 33.6563 13.7048 34.3068 15.4059 34.2931C17.1071 34.2793 18.7357 33.6023 19.9455 32.4063C21.1552 31.2101 21.8506 29.5893 21.8837 27.8883C21.9168 26.1876 21.285 24.5408 20.1227 23.2986L12.2005 15.3764Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Pharmacy Management</h3>
                  <p className="tn-sub-des">Automate and</p>
                  <p className="tn-sub-des">streamline</p>
                  <p className="tn-sub-des">pharmacy</p>
                  <p className="tn-sub-des">operations with</p>
                  <p className="tn-sub-des">tailored</p>
                  <p className="tn-sub-des">management</p>
                  <p className="tn-sub-des">systems.</p>
               </div>
               <div className="tn-content-wrap tn-13">
                  <svg
                     width="58"
                     height="57"
                     viewBox="0 0 58 57"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M23.7155 49.4267H4.88672C3.89217 49.4267 2.93832 49.0317 2.23507 48.3285C1.53182 47.6252 1.13672 46.6712 1.13672 45.6767V4.42677C1.13672 3.43219 1.53182 2.47837 2.23507 1.77512C2.93832 1.07184 3.89217 0.676758 4.88672 0.676758H31.4593C32.453 0.67697 33.4063 1.07172 34.1093 1.77427L41.2893 8.95427C41.9918 9.65724 42.3865 10.6104 42.3868 11.6043V23.2901M20.9671 21.1913C18.3961 21.1913 15.9304 22.2126 14.1124 24.0305C12.2945 25.8485 11.2731 28.3142 11.2731 30.8852H30.661C30.661 28.3142 29.6398 25.8485 27.8218 24.0305C26.0038 22.2126 23.538 21.1913 20.9671 21.1913ZM20.9671 21.1913C24.5363 21.1913 27.4298 18.2977 27.4298 14.7285C27.4298 11.1593 24.5365 8.26587 20.9673 8.26587C17.398 8.26587 14.5046 11.1593 14.5046 14.7285C14.5046 18.2977 17.3978 21.1913 20.9671 21.1913ZM48.8108 30.8855H39.3308V38.937H31.2795V48.417H39.3308V56.468H48.8108V48.417H56.862V38.937H48.8108V30.8855Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Healthcare CRM</h3>
                  <p className="tn-sub-des">Optimize patient</p>
                  <p className="tn-sub-des">interactions with</p>
                  <p className="tn-sub-des">advanced CRM</p>
                  <p className="tn-sub-des">systems.</p>
               </div>
               <div className="tn-content-wrap tn-14">
                  <svg
                     width="60"
                     height="54"
                     viewBox="0 0 60 54"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M22.5 53.375C24.6883 50.4731 25.9906 47.0002 26.25 43.375M37.5 53.375C35.3117 50.4731 34.0094 47.0002 33.75 43.375M18.75 53.375H41.25M1.25 35.875H58.75M1.25 20.875H16.6525C17.1641 20.8759 17.6247 20.5649 17.815 20.09L18.67 17.9475C18.8675 17.4543 19.3552 17.1399 19.886 17.1635C20.4168 17.1871 20.8746 17.5437 21.0275 18.0525L22.54 23.095C22.697 23.6262 23.1848 23.9907 23.7388 23.9907C24.2927 23.9907 24.7805 23.6262 24.9375 23.095L28.57 10.7475C28.7322 10.1957 29.25 9.8258 29.8246 9.85127C30.3992 9.87674 30.8822 10.291 30.995 10.855L34.0325 26.04C34.145 26.6007 34.6237 27.0135 35.1949 27.0424C35.766 27.0713 36.2839 26.7089 36.4525 26.1625L38.9525 18.015C39.1083 17.5087 39.5663 17.1556 40.0955 17.1336C40.6248 17.1117 41.1104 17.4258 41.3075 17.9175L42.1775 20.0975C42.3678 20.5724 42.8284 20.8834 43.34 20.8825H58.75M3.75 0.875H56.25C56.25 0.875 58.75 0.875 58.75 3.375V40.875C58.75 40.875 58.75 43.375 56.25 43.375H3.75C3.75 43.375 1.25 43.375 1.25 40.875V3.375C1.25 3.375 1.25 0.875 3.75 0.875Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Remote Monitoring</h3>
                  <p className="tn-sub-des">Enable real-time</p>
                  <p className="tn-sub-des">care with RPM</p>
                  <p className="tn-sub-des">platforms.</p>
               </div>
               <div className="tn-content-wrap tn-15">
                  <svg
                     width="56"
                     height="57"
                     viewBox="0 0 56 57"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M0.746094 2.32689V55.7112H54.1304M8.59947 40.0987L18.4776 48.0127L34.2826 29.0192L47.0409 40.0987M18.4219 6.58791H10.2148M22.7322 14.7947H10.2153M48.7444 1.42969H41.0819V7.93756H34.5741V15.6001H41.0819V22.1077H48.7444V15.6001H55.2521V7.93756H48.7444V1.42969Z"
                        stroke="#1F473E"
                     />
                  </svg>

                  <h3 className="tn-title">Revenue Cycle</h3>
                  <p className="tn-sub-des">Improve financial</p>
                  <p className="tn-sub-des">accuracy with</p>
                  <p className="tn-sub-des">automated billing</p>
                  <p className="tn-sub-des">and RCM</p>
                  <p className="tn-sub-des">solutions.</p>
               </div>
            </div>

            <div className="d-md-none d-block slider-column mt-5">
               <div className="model_train_slider container-fluid position-relative mb-3">
                  <Swiper
                     modules={[Navigation, Pagination, Autoplay]}
                     loop={true}
                     centeredSlides={true}
                     autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                     }}
                     speed={1000}
                     slidesPerView={1}
                     pagination={{
                        el: '.fintach-pagination',
                        dynamicBullets: false,
                        clickable: true,
                        renderBullet: function (index, className) {
                           return `<span class="${className} custom-dark-bullet"></span>`
                        },
                     }}
                     navigation={{
                        nextEl: '.model_train_slider_custom_next_btn3',
                        prevEl: '.model_train_slider_custom_prev_btn3',
                     }}
                     breakpoints={{
                        320: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        768: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1025: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1200: {
                           slidesPerView: 2,
                           spaceBetween: 30,
                        },
                     }}
                     className="service-slider tn-section1"
                  >
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-1">
                           <svg
                              className="tn-content-wrap-icon"
                              width="60"
                              height="54"
                              viewBox="0 0 60 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M7.5 53.25H51.25C55.3921 53.25 58.75 49.8921 58.75 45.75V17C58.75 16.3096 58.1904 15.75 57.5 15.75H15C14.3096 15.75 13.75 16.3096 13.75 17V47C13.75 50.4518 10.9518 53.25 7.5 53.25ZM7.5 53.25C4.04822 53.25 1.25 50.4518 1.25 47V2C1.25 1.30964 1.80964 0.75 2.5 0.75H17.5C18.1904 0.75 18.75 1.30964 18.75 2V7C18.75 7.69036 19.3096 8.25 20 8.25H51.25M46.25 32C46.25 31.3096 45.6904 30.75 45 30.75H38.75V24.5C38.75 23.8096 38.1904 23.25 37.5 23.25H32.5C31.8096 23.25 31.25 23.8096 31.25 24.5V30.75H25C24.3096 30.75 23.75 31.3096 23.75 32V37C23.75 37.6904 24.3096 38.25 25 38.25H31.25V44.5C31.25 45.1904 31.8096 45.75 32.5 45.75H37.5C38.1904 45.75 38.75 45.1904 38.75 44.5V38.25H45C45.6904 38.25 46.25 37.6904 46.25 37V32Z"
                                 stroke="#1F473E"
                              />
                           </svg>
                           <h3 className="tn-title">EMR/EHR Platforms</h3>
                           <p className="tn-sub-des">Digitize clinical</p>
                           <p className="tn-sub-des">workflows with EMR</p>
                           <p className="tn-sub-des">and EHR systems.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-2">
                           <svg
                              className="tn-content-wrap-icon"
                              width="58"
                              height="58"
                              viewBox="0 0 58 58"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M30.4632 57.3392H4.79245C2.64065 57.3392 0.757812 55.4565 0.757812 53.3047V4.6948C0.757812 2.543 2.64065 0.660156 4.79245 0.660156H53.2083C55.36 0.660156 57.2428 2.543 57.2428 4.6948V36.017M0.757812 15.7774H57.2428M46.7588 34.5983V41.0312M43.3237 47.7362V50.6405M50.1963 47.7362V50.6405M29.0115 10.7711C30.3878 10.7711 31.5035 9.6554 31.5035 8.2791C31.5035 6.90283 30.3878 5.7871 29.0115 5.7871C27.6353 5.7871 26.5195 6.90283 26.5195 8.2791C26.5195 9.6554 27.6353 10.7711 29.0115 10.7711ZM19.0262 10.7711C20.4025 10.7711 21.5182 9.6554 21.5182 8.2791C21.5182 6.90283 20.4025 5.7871 19.0262 5.7871C17.6499 5.7871 16.5342 6.90283 16.5342 8.2791C16.5342 9.6554 17.6499 10.7711 19.0262 10.7711ZM9.0457 10.7711C10.422 10.7711 11.5377 9.6554 11.5377 8.2791C11.5377 6.90283 10.422 5.7871 9.0457 5.7871C7.66943 5.7871 6.5537 6.90283 6.5537 8.2791C6.5537 9.6554 7.66943 10.7711 9.0457 10.7711ZM41.2775 41.0325H52.2425C52.2425 41.0325 57.2425 41.0325 57.2425 46.0325V52.3425C57.2425 52.3425 57.2425 57.3425 52.2425 57.3425H41.2775C41.2775 57.3425 36.2775 57.3425 36.2775 52.3425V46.0325C36.2775 46.0325 36.2775 41.0325 41.2775 41.0325Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">AI Solutions</h3>
                           <p className="tn-sub-des">Optimize healthcare</p>
                           <p className="tn-sub-des">processes using AI</p>
                           <p className="tn-sub-des">and machine</p>
                           <p className="tn-sub-des">learning.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-3">
                           <svg
                              className="tn-content-wrap-icon"
                              width="57"
                              height="56"
                              viewBox="0 0 57 56"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M47.906 12.5295V4.89273C47.906 3.77846 47.4633 2.70983 46.6753 1.92193C45.8875 1.13403 44.8188 0.691406 43.7045 0.691406H10.0941C8.97978 0.691406 7.91116 1.13403 7.12325 1.92193C6.33536 2.70983 5.89273 3.77846 5.89273 4.89273V30.1006L1.69141 42.7046L9.43636 40.2803H13.1635M41.604 51.1071L56.3088 55.3086L54.208 42.7046V23.5801C54.208 22.4658 53.7655 21.3971 52.9775 20.6092C52.1895 19.8213 51.121 19.3787 50.0068 19.3787H22.6982C21.5839 19.3787 20.5153 19.8213 19.7274 20.6092C18.9395 21.3971 18.4968 22.4658 18.4968 23.5801L18.4969 46.9058C18.4969 48.0201 18.9395 49.0888 19.7274 49.8766C20.5153 50.6646 21.5839 51.1071 22.6982 51.1071H41.604ZM40.3738 26.4511H32.933V31.6403H27.541V39.0808H32.933V44.2701H40.3738V39.0808H45.3598V31.6403H40.3738V26.4511Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Patient Engagement</h3>
                           <p className="tn-sub-des">Enhance patient</p>
                           <p className="tn-sub-des">relationships with</p>
                           <p className="tn-sub-des">interactive software.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-4">
                           <svg
                              className="tn-content-wrap-icon"
                              width="60"
                              height="59"
                              viewBox="0 0 60 59"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M1.25 33.75V58.75M58.75 40V58.75M28.75 11.25H34.375C34.7684 11.25 35.1389 11.0648 35.375 10.75L37.655 7.7075C37.9023 7.37776 38.2962 7.19113 38.708 7.20862C39.1198 7.22612 39.4966 7.44548 39.715 7.795L44.165 14.9175C44.3667 15.2411 44.705 15.4549 45.0838 15.4983C45.4626 15.5416 45.8405 15.4097 46.11 15.14L49.6325 11.6175C49.8674 11.3832 50.1858 11.2519 50.5175 11.2525H58.75M6.25 40C6.25 43.4518 9.04822 46.25 12.5 46.25C15.9518 46.25 18.75 43.4518 18.75 40C18.75 36.5482 15.9518 33.75 12.5 33.75C9.04822 33.75 6.25 36.5482 6.25 40ZM1.25 46.25H58.75V53.75H1.25V46.25ZM23.75 46.25H53.75V38.75C53.75 35.9886 51.5114 33.75 48.75 33.75H25C24.3096 33.75 23.75 34.3096 23.75 35V46.25ZM28.75 18.75C28.75 20.1307 29.8693 21.25 31.25 21.25H56.25C57.6307 21.25 58.75 20.1307 58.75 18.75V3.75C58.75 2.36929 57.6307 1.25 56.25 1.25H31.25C29.8693 1.25 28.75 2.36929 28.75 3.75V18.75Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Hospital Administration</h3>
                           <p className="tn-sub-des">Simplify</p>
                           <p className="tn-sub-des">management with</p>
                           <p className="tn-sub-des">custom hospital</p>
                           <p className="tn-sub-des">software.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-5">
                           <svg
                              className="tn-content-wrap-icon"
                              width="59"
                              height="60"
                              viewBox="0 0 59 60"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M40.8613 28.75V40L33.2113 46.695C31.7179 48.0011 30.8612 49.8885 30.8613 51.8725C30.8599 55.6695 33.9369 58.7486 37.7338 58.75H51.4838C55.2808 58.75 58.3588 55.672 58.3588 51.875C58.3592 49.8922 57.5035 48.0058 56.0113 46.7L48.3613 40V28.75M31.0863 53.615L36.1938 51.0825C39.1087 49.6231 42.5601 49.7169 45.3913 51.3325C48.0454 52.8506 51.2579 53.0357 54.0688 51.8325L58.1113 50.05M25.8613 51.25H3.36133C1.98062 51.25 0.861328 50.1307 0.861328 48.75V11.25C0.861328 9.86929 1.98062 8.75 3.36133 8.75H10.8613M30.8613 8.75H38.3613C39.742 8.75 40.8613 9.86929 40.8613 11.25V23.75M37.1113 28.75H52.1113M12.1113 23.75H29.6113M12.1113 31.25H22.7363M29.6113 43.75H5.86133V13.75H10.8613M30.8613 13.75H35.8613V23.75M25.8613 6.25C25.8613 3.48858 23.6228 1.25 20.8613 1.25C18.0999 1.25 15.8613 3.48858 15.8613 6.25H12.1113C11.421 6.25 10.8613 6.80964 10.8613 7.5V15C10.8613 15.6904 11.421 16.25 12.1113 16.25H29.6113C30.3017 16.25 30.8613 15.6904 30.8613 15V7.5C30.8613 6.80964 30.3017 6.25 29.6113 6.25H25.8613Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Laboratory Management</h3>
                           <p className="tn-sub-des">Automate lab</p>
                           <p className="tn-sub-des">operations with</p>
                           <p className="tn-sub-des">LIMS platforms.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-6">
                           <svg
                              className="tn-content-wrap-icon"
                              width="58"
                              height="58"
                              viewBox="0 0 58 58"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M56.7021 30.6036V5.53517C56.7021 4.39977 56.2511 3.31087 55.4481 2.50805C54.6454 1.7052 53.5564 1.25415 52.4211 1.25415H9.61079C8.47539 1.25415 7.38649 1.7052 6.58364 2.50805C5.78079 3.31087 5.32976 4.39977 5.32976 5.53517V33.5454L1.04883 48.1964L18.1728 42.1074H20.8906M44.3704 12.3528H16.0778M27.5191 20.9436H16.078M47.8249 28.7016H37.3721V37.5791H28.4946V48.0319H37.3721V56.9094H47.8246V48.0319H56.7021V37.5791H47.8249V28.7016Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Medical Device Software</h3>
                           <p className="tn-sub-des">Ensure functionality</p>
                           <p className="tn-sub-des">and connectivity for</p>
                           <p className="tn-sub-des">medical devices.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-7">
                           <svg
                              className="tn-content-wrap-icon"
                              width="60"
                              height="60"
                              viewBox="0 0 60 60"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M28.7539 58.75H3.75391C2.37319 58.75 1.25391 57.6307 1.25391 56.25V3.75001C1.25391 2.3693 2.37319 1.25001 3.75391 1.25001H36.9789C37.6445 1.24816 38.2833 1.51179 38.7539 1.98251L48.0039 11.25C48.4728 11.7187 48.7363 12.3545 48.7364 13.0175V21.25M8.74641 38.75H31.2464M26.2539 38.75V20C26.2539 19.3097 25.6943 18.75 25.0039 18.75H22.5039C21.8136 18.75 21.2539 19.3097 21.2539 20V38.75M36.2539 28.75V25C36.2539 24.3097 35.6943 23.75 35.0039 23.75H32.5039C31.8136 23.75 31.2539 24.3097 31.2539 25V38.75M12.5039 26.25H15.0039C15.6943 26.25 16.2539 26.8097 16.2539 27.5V38.75H11.2539V27.5C11.2539 26.8097 11.8135 26.25 12.5039 26.25ZM38.7464 38.7525H56.2464C56.2464 38.7525 58.7464 38.7525 58.7464 41.2525V56.25C58.7464 56.25 58.7464 58.75 56.2464 58.75H38.7464C38.7464 58.75 36.2464 58.75 36.2464 56.25V41.2525C36.2464 41.2525 36.2464 38.7525 38.7464 38.7525ZM44.3714 48.9075C44.3714 50.6334 45.7705 52.0325 47.4964 52.0325C49.2223 52.0325 50.6214 50.6334 50.6214 48.9075C50.6214 47.1816 49.2223 45.7825 47.4964 45.7825C45.7705 45.7825 44.3714 47.1816 44.3714 48.9075ZM53.7539 35C53.7539 31.5482 50.9557 28.75 47.5039 28.75C44.0521 28.75 41.2539 31.5482 41.2539 35V38.75H53.7539V35Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Data Security</h3>
                           <p className="tn-sub-des">Protect patient</p>
                           <p className="tn-sub-des">information with</p>
                           <p className="tn-sub-des">secure software</p>
                           <p className="tn-sub-des">solutions.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-8">
                           <svg
                              className="tn-content-wrap-icon"
                              width="52"
                              height="61"
                              viewBox="0 0 52 61"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M43 16.25C41.6738 20.6273 40.9999 25.1762 41 29.75C41.163 39.4333 42.3225 49.0741 44.46 58.52C44.6247 59.2379 45.2635 59.7467 46 59.7467C46.7365 59.7467 47.3753 59.2379 47.54 58.52C49.6775 49.0741 50.837 39.4333 51 29.75C51.0001 25.1762 50.3262 20.6273 49 16.25M6 9.75H13.5M6 9.75V32.25M6 9.75C3.23858 9.75 1 11.9886 1 14.75V32.25M6 9.75V6C6 3.92893 7.67893 2.25 9.75 2.25C11.8211 2.25 13.5 3.92893 13.5 6V9.75M13.5 9.75V32.25M13.5 32.25H6M13.5 32.25V49.75M6 32.25V49.75M31 11V49.75M31 11L27.25 12.25L23.5 11M31 11L27.25 2.25L23.5 11M31 49.75H23.5M31 49.75V54.75M23.5 49.75V11M23.5 49.75V54.75M13.5 49.75H6M13.5 49.75C12.9342 52.7166 12.2132 55.6514 11.34 58.5425C11.1419 59.257 10.4915 59.7516 9.75 59.7516C9.00854 59.7516 8.35813 59.257 8.16 58.5425C7.2868 55.6514 6.56581 52.7166 6 49.75M23.5 54.75V56C23.5 58.0711 25.1789 59.75 27.25 59.75C29.3211 59.75 31 58.0711 31 56V54.75M23.5 54.75H31M46 2.25C49.3325 3.9175 51 8.9175 51 12.25C51 15.0114 48.7614 17.25 46 17.25C43.2386 17.25 41 15.0114 41 12.25C41 7.7875 46.8325 7.615 46 2.25Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Practice Management</h3>
                           <p className="tn-sub-des">Boost efficiency with</p>
                           <p className="tn-sub-des">all-in-one</p>
                           <p className="tn-sub-des">management</p>
                           <p className="tn-sub-des">systems.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-9">
                           <svg
                              className="tn-content-wrap-icon"
                              width="58"
                              height="58"
                              viewBox="0 0 58 58"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M14.365 40.1591L0.818359 44.8781L5.0993 30.2271V5.5352C5.0993 4.3998 5.55032 3.3109 6.35317 2.50805C7.15602 1.7052 8.24492 1.25416 9.38032 1.25416L42.9756 1.25415C44.1109 1.25415 45.1999 1.7052 46.0026 2.50805C46.8056 3.31087 47.2566 4.39977 47.2566 5.53517V27.8654M25.7046 18.9818C23.3658 18.9818 21.1227 19.9109 19.4688 21.5648C17.815 23.2186 16.8859 25.4619 16.8859 27.8006H34.5236C34.5236 25.4619 33.5944 23.2186 31.9406 21.5648C30.2866 19.9109 28.0436 18.9818 25.7046 18.9818ZM25.7046 18.9818C28.6204 18.9818 30.9844 16.6182 30.9844 13.7024C30.9844 10.7866 28.6206 8.42287 25.7049 8.42287C22.789 8.42287 20.4253 10.7866 20.4253 13.7024C20.4253 16.6182 22.7887 18.9818 25.7046 18.9818ZM44.1904 34.0694H22.2916C20.8566 34.0694 19.6934 35.2326 19.6934 36.6676V54.8544C19.6934 56.2894 20.8566 57.4526 22.2916 57.4526H44.1904C45.6254 57.4526 46.7886 56.2894 46.7886 54.8544V36.6676C46.7886 35.2326 45.6254 34.0694 44.1904 34.0694ZM46.7889 49.6569L55.4267 52.8959C55.6231 52.9694 55.8346 52.9944 56.0426 52.9684C56.2509 52.9424 56.4496 52.8666 56.6221 52.7471C56.7946 52.6276 56.9356 52.4681 57.0329 52.2821C57.1304 52.0964 57.1811 51.8896 57.1814 51.6799V39.8394C57.1811 39.6296 57.1299 39.4234 57.0324 39.2376C56.9351 39.0521 56.7939 38.8929 56.6217 38.7736C56.4492 38.6546 56.2502 38.5789 56.0421 38.5534C55.8341 38.5279 55.6229 38.5531 55.4267 38.6269L46.7889 41.8659V49.6569ZM30.2681 39.0096H35.9066V42.9419H39.9924V48.5801H35.9066V52.5124H30.2681V48.5801H26.4896V42.9419H30.2681V39.0096Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Telehealth Platforms</h3>
                           <p className="tn-sub-des">Expand care access</p>
                           <p className="tn-sub-des">with secure</p>
                           <p className="tn-sub-des">telehealth solutions.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-10">
                           <svg
                              className="tn-content-wrap-icon"
                              width="44"
                              height="56"
                              viewBox="0 0 44 56"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M21.999 23.0689C26.212 23.0689 29.6272 19.6536 29.6272 15.4406C29.6272 11.2276 26.212 7.81234 21.999 7.81234C17.786 7.81234 14.3707 11.2276 14.3707 15.4406C14.3707 19.6536 17.786 23.0689 21.999 23.0689ZM21.999 23.0689C18.2418 23.0689 14.6382 24.5617 11.9814 27.2184C9.3246 29.8752 7.83205 33.4784 7.83205 37.2359M21.999 23.0689C25.7564 23.0689 29.3595 24.5617 32.0162 27.2184C34.6732 29.8752 36.1657 33.4784 36.1657 37.2359M14.3707 33.2992H20.6642M17.5171 30.1522V36.4457M18.8355 48.5154H25.1627M43.0902 4.80001C43.0902 2.47036 41.2017 0.581787 38.8722 0.581787H5.12643C2.79678 0.581787 0.908203 2.47036 0.908203 4.80001V51.2004C0.908203 53.5299 2.79678 55.4187 5.12643 55.4187H38.8722C41.2017 55.4187 43.0902 53.5299 43.0902 51.2004V4.80001Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Precision Medicine</h3>
                           <p className="tn-sub-des">Deliver</p>
                           <p className="tn-sub-des">personalized care</p>
                           <p className="tn-sub-des">with precision</p>
                           <p className="tn-sub-des">medicine</p>
                           <p className="tn-sub-des">solutions.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-11">
                           <svg
                              className="tn-content-wrap-icon"
                              width="56"
                              height="56"
                              viewBox="0 0 56 56"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M28.9357 6.81682H2.79013C1.62995 6.81682 0.689453 7.75732 0.689453 8.9175V42.5284C0.689453 43.6884 1.62995 44.6289 2.79013 44.6289H53.2064C54.3667 44.6289 55.3072 43.6884 55.3072 42.5284V20.7509M23.7967 44.6289L19.5954 55.1324M32.1994 44.6289L36.4009 55.1324M15.394 55.1324H40.6022M11.1802 37.7416L19.6777 28.2859L25.5427 33.4326L34.1607 24.3361M17.479 14.771H9.3818M12.9771 22.1554H9.38048M48.8864 0.86792H41.3264V7.28867H34.9057V14.8486H41.3264V21.2691H48.8864V14.8486H55.3069V7.28867H48.8864V0.86792Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Medical Imaging</h3>
                           <p className="tn-sub-des">Improve</p>
                           <p className="tn-sub-des">diagnostic</p>
                           <p className="tn-sub-des">accuracy with</p>
                           <p className="tn-sub-des">advanced</p>
                           <p className="tn-sub-des">imaging solutions.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-12">
                           <svg
                              className="tn-content-wrap-icon"
                              width="58"
                              height="58"
                              viewBox="0 0 58 58"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M50.2231 50.2968L56.8169 56.8903M15.7677 18.9445L6.53394 28.1783M20.1456 9.34797C20.1456 13.8522 23.797 17.5035 28.3011 17.5035C32.8054 17.5035 36.4569 13.8522 36.4569 9.34797M20.1456 9.34797C20.1456 4.84377 23.797 1.19238 28.3011 1.19238C32.8054 1.19238 36.4569 4.84377 36.4569 9.34797M20.1456 9.34797H36.4569M40.0916 54.5016C48.0081 54.5016 54.4254 48.0841 54.4254 40.1678C54.4254 32.2513 48.0081 25.8338 40.0916 25.8338C32.1754 25.8338 25.7579 32.2513 25.7579 40.1678C25.7579 48.0841 32.1754 54.5016 40.0916 54.5016ZM12.2005 15.3764C10.9647 14.2082 9.32204 13.5681 7.62164 13.592C5.92127 13.6159 4.29724 14.302 3.09477 15.5045C1.8923 16.7069 1.20619 18.331 1.18229 20.0313C1.15838 21.7317 1.79857 23.3744 2.96674 24.6103L10.8364 32.4798C12.0654 33.6563 13.7048 34.3068 15.4059 34.2931C17.1071 34.2793 18.7357 33.6023 19.9455 32.4063C21.1552 31.2101 21.8506 29.5893 21.8837 27.8883C21.9168 26.1876 21.285 24.5408 20.1227 23.2986L12.2005 15.3764Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Pharmacy Management</h3>
                           <p className="tn-sub-des">Automate and</p>
                           <p className="tn-sub-des">streamline</p>
                           <p className="tn-sub-des">pharmacy</p>
                           <p className="tn-sub-des">operations with</p>
                           <p className="tn-sub-des">tailored</p>
                           <p className="tn-sub-des">management</p>
                           <p className="tn-sub-des">systems.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-13">
                           <svg
                              className="tn-content-wrap-icon"
                              width="58"
                              height="57"
                              viewBox="0 0 58 57"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M23.7155 49.4267H4.88672C3.89217 49.4267 2.93832 49.0317 2.23507 48.3285C1.53182 47.6252 1.13672 46.6712 1.13672 45.6767V4.42677C1.13672 3.43219 1.53182 2.47837 2.23507 1.77512C2.93832 1.07184 3.89217 0.676758 4.88672 0.676758H31.4593C32.453 0.67697 33.4063 1.07172 34.1093 1.77427L41.2893 8.95427C41.9918 9.65724 42.3865 10.6104 42.3868 11.6043V23.2901M20.9671 21.1913C18.3961 21.1913 15.9304 22.2126 14.1124 24.0305C12.2945 25.8485 11.2731 28.3142 11.2731 30.8852H30.661C30.661 28.3142 29.6398 25.8485 27.8218 24.0305C26.0038 22.2126 23.538 21.1913 20.9671 21.1913ZM20.9671 21.1913C24.5363 21.1913 27.4298 18.2977 27.4298 14.7285C27.4298 11.1593 24.5365 8.26587 20.9673 8.26587C17.398 8.26587 14.5046 11.1593 14.5046 14.7285C14.5046 18.2977 17.3978 21.1913 20.9671 21.1913ZM48.8108 30.8855H39.3308V38.937H31.2795V48.417H39.3308V56.468H48.8108V48.417H56.862V38.937H48.8108V30.8855Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Healthcare CRM</h3>
                           <p className="tn-sub-des">Optimize patient</p>
                           <p className="tn-sub-des">interactions with</p>
                           <p className="tn-sub-des">advanced CRM</p>
                           <p className="tn-sub-des">systems.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-14">
                           <svg
                              className="tn-content-wrap-icon"
                              width="60"
                              height="54"
                              viewBox="0 0 60 54"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M22.5 53.375C24.6883 50.4731 25.9906 47.0002 26.25 43.375M37.5 53.375C35.3117 50.4731 34.0094 47.0002 33.75 43.375M18.75 53.375H41.25M1.25 35.875H58.75M1.25 20.875H16.6525C17.1641 20.8759 17.6247 20.5649 17.815 20.09L18.67 17.9475C18.8675 17.4543 19.3552 17.1399 19.886 17.1635C20.4168 17.1871 20.8746 17.5437 21.0275 18.0525L22.54 23.095C22.697 23.6262 23.1848 23.9907 23.7388 23.9907C24.2927 23.9907 24.7805 23.6262 24.9375 23.095L28.57 10.7475C28.7322 10.1957 29.25 9.8258 29.8246 9.85127C30.3992 9.87674 30.8822 10.291 30.995 10.855L34.0325 26.04C34.145 26.6007 34.6237 27.0135 35.1949 27.0424C35.766 27.0713 36.2839 26.7089 36.4525 26.1625L38.9525 18.015C39.1083 17.5087 39.5663 17.1556 40.0955 17.1336C40.6248 17.1117 41.1104 17.4258 41.3075 17.9175L42.1775 20.0975C42.3678 20.5724 42.8284 20.8834 43.34 20.8825H58.75M3.75 0.875H56.25C56.25 0.875 58.75 0.875 58.75 3.375V40.875C58.75 40.875 58.75 43.375 56.25 43.375H3.75C3.75 43.375 1.25 43.375 1.25 40.875V3.375C1.25 3.375 1.25 0.875 3.75 0.875Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Remote Monitoring</h3>
                           <p className="tn-sub-des">Enable real-time</p>
                           <p className="tn-sub-des">care with RPM</p>
                           <p className="tn-sub-des">platforms.</p>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="tn-content-wrap tn-15">
                           <svg
                              className="tn-content-wrap-icon"
                              width="56"
                              height="57"
                              viewBox="0 0 56 57"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M0.746094 2.32689V55.7112H54.1304M8.59947 40.0987L18.4776 48.0127L34.2826 29.0192L47.0409 40.0987M18.4219 6.58791H10.2148M22.7322 14.7947H10.2153M48.7444 1.42969H41.0819V7.93756H34.5741V15.6001H41.0819V22.1077H48.7444V15.6001H55.2521V7.93756H48.7444V1.42969Z"
                                 stroke="#1F473E"
                              />
                           </svg>

                           <h3 className="tn-title">Revenue Cycle</h3>
                           <p className="tn-sub-des">Improve financial</p>
                           <p className="tn-sub-des">accuracy with</p>
                           <p className="tn-sub-des">automated billing</p>
                           <p className="tn-sub-des">and RCM</p>
                           <p className="tn-sub-des">solutions.</p>
                        </div>
                     </SwiperSlide>
                     <div className="model_train_slider_custom_prev_btn3"></div>
                     <div className="model_train_slider_custom_next_btn3"></div>
                     <div className="d-xl-none d-flex align-items-center justify-content-center mt-3">
                        <span className="d-flex align-items-center justify-content-center fintach-pagination"></span>
                     </div>
                  </Swiper>
               </div>
            </div>
         </div>
      </section>
   )
}

export default TopNotchFeatures
